import React from "react";
import { TextField } from "@mui/material";
import { InputTextProps } from "./InputTextProps";

export const InputText = ({
                                                        value,
                                                        handleValue,
                                                        label,
                                                        name,
                                                        required,
                                                        idField,
                                                        typeFiled,
                                                        multiline = false,
                                                        minRows = 1,
                                                    }: InputTextProps) => {
    return (
        <TextField
            fullWidth
            variant="filled"
            size="medium"
            name={name}
            required={required}
            id={idField}
            label={label}
            value={value}
            onChange={handleValue}
            type={typeFiled ?? "text"}
            placeholder=" "
            multiline={multiline}
            minRows={multiline ? minRows : undefined}
            InputLabelProps={{ shrink: true }}
            InputProps={{ disableUnderline: true }}
            sx={{
                "& .MuiFilledInput-root": {
                    borderRadius: "14px",
                    backgroundColor: "#fff",
                    border: "1px solid #E5E7EB",
                    minHeight: multiline ? "120px" : "42px",
                    alignItems: multiline ? "flex-start" : "center",
                    overflow: "visible",
                    transition: "all 0.2s ease",
                },
                "& .MuiFilledInput-root:hover": {
                    backgroundColor: "#fff",
                    borderColor: "#d1d5db",
                },
                "& .MuiFilledInput-root.Mui-focused": {
                    backgroundColor: "#fff",
                    borderColor: "#22C55E",
                    boxShadow: "0 0 0 3px rgba(34, 197, 94, 0.15)",
                },
                "& .MuiFilledInput-root:before, & .MuiFilledInput-root:after": {
                    display: "none",
                },
                "& .MuiFilledInput-input": {
                    padding: multiline ? "28px 16px 16px 16px" : "20px 16px 12px 16px",
                    fontSize: "14px",
                    lineHeight: 1.4,
                    boxSizing: "border-box",
                },
                "& textarea.MuiFilledInput-input": {
                    padding: "28px 16px 16px 16px",
                    resize: "vertical",
                },
                "& .MuiInputLabel-root": {
                    color: "#64748b",
                    fontSize: "14px",
                    transform: multiline
                        ? "translate(12px, 16px) scale(1)"
                        : "translate(12px, 17px) scale(1)",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                    color: "#22c55e",
                },
                "& .MuiInputLabel-root.MuiInputLabel-shrink": {
                    transform: "translate(12px, -9px) scale(0.82)",
                    backgroundColor: "#fff",
                    padding: "0 6px",
                    borderRadius: "8px",
                },
            }}
        />
    );
};

export default InputText;